import { FOOTER_MJML } from "../common/footer";
import { TRANSACTIONAL_HEADER } from "../common/header";

export const pendingPayment = `
<mjml>
  <mj-head>
    <mj-title>Payment Reminder | Copilotly</mj-title>
    <mj-preview>Your payment is pending for the upcoming event. Please complete your transaction.</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
      <mj-section padding="0px" />
    </mj-attributes>
    <mj-style>
      .reminder-container { border-radius: 8px; overflow: hidden; }
      .payment-info { width: 100%; }
      .payment-info td { padding: 10px 0; }
      .payment-info tr { border-bottom: 1px solid #e0e0e0; }
      .countdown-timer { font-family: monospace; letter-spacing: 1px; }
      .payment-methods img { margin-right: 10px; }
      .status-pending { background-color: #FFF4E5; color: #FF9800; border-radius: 4px; padding: 5px 10px; font-weight: bold; }
      .timeline-container { border-left: 2px solid #e0e0e0; padding-left: 20px; margin-left: 10px; }
      .timeline-item { position: relative; margin-bottom: 15px; }
      .timeline-circle { width: 12px; height: 12px; border-radius: 50%; background-color: #e0e0e0; position: absolute; left: -26px; top: 5px; }
      .timeline-active { background-color: #336633; }
      @media (max-width: 480px) {
        .mobile-block { display: block !important; width: 100% !important; }
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f5f5f5">
    ${TRANSACTIONAL_HEADER(
      "Payment Reminder",
      "Your registration is almost complete"
    )}
    
    <!-- Reminder Banner -->
    <mj-section background-color="#ffffff" padding="30px 20px 20px" css-class="reminder-container">
      <mj-column>
        <mj-text font-size="22px" color="#336633" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">We noticed that you started registering for our upcoming event but haven't completed your payment yet. Your registration is currently on hold and seats will only be confirmed after payment is received.</mj-text>
        <mj-text font-size="16px" font-style="italic" color="#666666" font-family="Arial, sans-serif" padding-bottom="10px">"We may not live in Bihar, Jharkhand, and Uttar Pradesh, but their spirit lives in us."</mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Payment Status -->
    <mj-section background-color="#ffffff" padding="0px 20px" css-class="reminder-container">
      <mj-column>
        <mj-text align="center" padding-bottom="20px">
          <span class="status-pending">⏱ PAYMENT PENDING</span>
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Countdown Timer -->
    <mj-section background-color="#ffffff" padding="0px 20px" css-class="reminder-container">
      <mj-column background-color="#f9f9f9" border-radius="8px" padding="15px">
        <mj-text font-size="14px" color="#555555" align="center">Your reservation will expire in:</mj-text>
        <mj-text font-size="24px" color="#FF9800" font-weight="bold" align="center" css-class="countdown-timer">
          {{hours}}:{{minutes}}:{{seconds}}
        </mj-text>
        <mj-text font-size="12px" color="#777777" align="center">
          Reservation made on {{reservation_date}} at {{reservation_time}}
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Order Summary -->
    <mj-section background-color="#ffffff" padding="20px" css-class="reminder-container">
      <mj-column>
        <mj-text font-size="18px" color="#1a2310" font-weight="bold" padding-bottom="10px">Your Order Summary</mj-text>
        <mj-table css-class="payment-info">
          <tr>
            <td style="width: 40%; color: #777777;">Event</td>
            <td style="width: 60%; color: #333333; font-weight: bold;">{{event_name}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Date & Time</td>
            <td style="width: 60%; color: #333333;">{{event_date}} at {{event_time}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Venue</td>
            <td style="width: 60%; color: #333333;">{{event_venue}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Ticket Type</td>
            <td style="width: 60%; color: #333333;">{{ticket_type}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Quantity</td>
            <td style="width: 60%; color: #333333;">{{ticket_quantity}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Total Amount Due</td>
            <td style="width: 60%; color: #336633; font-weight: bold; font-size: 18px;">AED {{total_amount}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Order Reference</td>
            <td style="width: 60%; color: #333333;">ORD-{{order_reference}}</td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    
    <!-- Complete Payment Button -->
    <mj-section background-color="#ffffff" padding="0px 20px" css-class="reminder-container">
      <mj-column>
        <mj-button background-color="#FF9800" color="#ffffff" font-size="18px" border-radius="4px" href="#" width="300px">
          Complete Payment Now
        </mj-button>
      </mj-column>
    </mj-section>
    
    <!-- Payment Process Timeline -->
    <mj-section background-color="#ffffff" padding="20px" css-class="reminder-container">
      <mj-column>
        <mj-text font-size="18px" color="#1a2310" font-weight="bold" padding-bottom="15px">Your Registration Progress</mj-text>
        
        <mj-text css-class="timeline-container">
          <div class="timeline-item">
            <div class="timeline-circle timeline-active"></div>
            <div style="color: #336633; font-weight: bold;">Registration Started</div>
            <div style="color: #777777; font-size: 12px;">{{registration_date}}</div>
          </div>
          
          <div class="timeline-item">
            <div class="timeline-circle timeline-active"></div>
            <div style="color: #336633; font-weight: bold;">Tickets Reserved</div>
            <div style="color: #777777; font-size: 12px;">{{reservation_date}}</div>
          </div>
          
          <div class="timeline-item">
            <div class="timeline-circle"></div>
            <div>Payment Pending</div>
            <div style="color: #777777; font-size: 12px;">Awaiting your payment</div>
          </div>
          
          <div class="timeline-item">
            <div class="timeline-circle"></div>
            <div>Confirmation</div>
            <div style="color: #777777; font-size: 12px;">After payment is received</div>
          </div>
        </mj-text>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "pendingPayment",
  name: "Pending Payment Reminder",
  category: "transactional",
  purpose: "transactional" as const,
  description:
    "An urgent reminder template for pending payments with countdown timer, order summary, and registration progress timeline.",
  features: [
    "Countdown timer for urgency",
    "Registration progress timeline",
    "Order summary",
    "Payment methods display",
    "FAQ section",
  ],
  subject: "Payment Reminder | Copilotly",
  subTitle:
    "Your payment is pending for the upcoming event. Please complete your transaction.",
  mjmlTemplate: pendingPayment,
  tags: ["transactional", "payment", "reminder", "pending"],
};
